module.exports = __webpack_public_path__ + "static/media/5.4c6a3bc1.jpg";